import { useQuery } from 'react-query';
import { getDocumentList } from 'api/documents';

const useQueryDocuments = (commercialRelation: string) => {
  return useQuery(['documents-list'], () => getDocumentList(commercialRelation));
};

export { useQueryDocuments };
